// Router dashboard
import common from './dashboardChildren/common';
import coach from './dashboardChildren/coach';
import leader from './dashboardChildren/leader';
import oa from './dashboardChildren/oa';

const removedRoutes = process.env.VUE_APP_REMOVED_ROUTES
  ? process.env.VUE_APP_REMOVED_ROUTES.split(' ')
  : null;

export default [
  {
    path: '/dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../../views/dashboard/Dashboard.vue'),
    beforeEnter: (to, from, next) => {
      // check if user has token or redirect to login page
      // const storage = localStorage[process.env.VUE_APP_VUEX_KEY]
      //   ? JSON.parse(localStorage[process.env.VUE_APP_VUEX_KEY])
      //   : null;
      // console.log(storage);

      // if (!storage || !storage.user || !storage.user.user || !storage.user.user.uuid) {
      //   localStorage.removeItem(process.env.VUE_APP_VUEX_KEY);
      //   next({ name: 'login' });
      // }
      next();
    },

    // Dashboard children
    children: [
      ...common,
      ...leader,
      ...coach,
      ...oa,
    ].filter((el) => (removedRoutes ? !removedRoutes.includes(el.name) : true)),
  },
];
